// extracted by mini-css-extract-plugin
export default {"label":"M6V6gq mz-link","mobile":"MQQsho","label_icon":"P_Jo_P mz-compact-input__icon"};